module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ko":{"cancel":"취소"}}')
  delete Component.options._Ctor
}
